import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IPage } from '../../../../httpClient/serverApi/types/IPage';

export interface ISiteAdminProfile {
  luid: string;
  name: string;
  description?: string;
}

export interface IGetSiteAdminProfilesPagination {
  totalAvailable: number;
  pageNumber: number;
  pageSize: number;
}

export interface IGetSiteAdminProfilesResult {
  pagination: IGetSiteAdminProfilesPagination;
  adminProfiles: ISiteAdminProfile[];
}

export interface IGetSiteAdminProfilesParams {
  page?: IPage;
}

export class GetSiteAdminProfilesRequest extends Request<IGetSiteAdminProfilesParams, IGetSiteAdminProfilesResult> {
  constructor(params: IGetSiteAdminProfilesParams = {}) {
    super('getSiteAdminProfiles', params);
  }
}
